<template>
  <div class="p-grid panel-demo">
    <div class="p-col-12">
      <Toast />
      <div class="card">
        <h5><b>Import Stock</b></h5>
      </div>
      <div class="card" v-if="loading == false">
        <span class="btn btn-primary btn-file">
          Browse...
          <input
            class="btn btn-primary btn-file"
            type="file"
            id="file"
            accept=".csv"
            @change="onFileChange"
          />
        </span>
      </div>
      <div class="card" v-if="loading == true">
        <div class="p-col-12" style="overflow-x: auto">
          <table class="table table-responsive">
            <thead class="thead-light">
              <tr>
                <!-- <th>id</th> -->
                <th>Nama Outlet</th>
                <th>Nama Gudang</th>
                <th>Tipe</th>
                <th>Nomor Bon</th>
                <th>Tanggal</th>
                <th>Kode Item</th>
                <th>Jumlah</th>
                <th>Status</th>
                <!-- <th>created_at</th>
							<th>created_by</th>
							<th>updated_at</th>
							<th>updated_by</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(an_item, k) in detail" :key="k">
                <!-- <td v-for="(column, m) in an_item" :key="m">
								{{column}} </td> -->
                <!-- <td>{{an_item[k]}}</td> -->
                <td>{{ an_item[k + 13] }}</td>
                <td>{{ an_item[k + 14] }}</td>
                <td>{{ an_item[k + 3] }}</td>
                <td>{{ an_item[k + 4] }}</td>
                <td>{{ moment(an_item[k + 5]).format('DD-MM-YYYY') }}</td>
                <td>{{ an_item[k + 6] }}</td>
                <td>{{ an_item[k + 7] }}</td>
                <td>{{ an_item[k + 8] }}</td>
                <!-- <td>{{moment(an_item[k+9]).format("DD-MM-YYYY")}}</td>
							<td>{{an_item[k+10]}}</td>
							<td>{{moment(an_item[k+11]).format("DD-MM-YYYY")}}</td>
							<td>{{an_item[k+12]}}</td> -->
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td class="p-text-right">
                  <label>Total</label>
                </td>
                <td>
                  <label>{{ totalQty }}</label>
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        <br />
        <div class="p-grid p-justify-center">
          <div class="p-col-3">
            <Button
              type="button"
              style="width: 50%"
              label="Upload"
              @click="onUpload"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var moment = require('moment')
export default {
  data() {
    return {
      moment: moment,
      loading: false,
      fileinput: '',
      detail: [],
      outletNames: [],
      warehouseNames: [],
      fileCSV: null,
      totalQty: 0
    }
  },
  methods: {
    onFileChange(event) {
      var files = event.target.files || event.dataTransfer.files
      if (!files.length) return
      this.fileCSV = files[0]
      this.createInput(files[0])
    },
    createInput(file) {
      var counter = -1
      var reader = new FileReader()
      var vm = this
      this.loading = true
      reader.onload = () => {
        vm.fileinput = reader.result
        var files = vm.fileinput.split('\n')
        for (var a = 1; a < files.length; a++) {
          var splitted = files[a].split(',')
          if (splitted.length > 1) {
            counter += 8
            this.totalQty += +splitted[counter]
            vm.detail.push(splitted)
          }
        }
      }
      reader.readAsText(file)
    },
    onUpload() {
      this.loading = true
      var formData = new FormData()
      formData.set('file', this.fileCSV)
      this.$http
        .post(
          `${process.env.VUE_APP_API_URL}/dashboard/outlet-outbounds/csv`,
          formData
        )
        .then(response => {
          if (response.status == 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Success',
              detail: 'File Uploaded',
              life: 3000
            })
            setTimeout((this.loading = false), 10000)
          } else {
            setTimeout((this.loading = false), 10000)
            this.$toast.add({
              severity: 'error',
              summary: 'Failed',
              detail: 'Uploading failed',
              life: 3000
            })
          }
        })
    }
  }
}
</script>

<style scoped lang="scss">
p {
  line-height: 1.5;
  margin: 0;
}

/deep/ .p-card .p-card-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0;
}
.btn-file {
  position: relative;
  overflow: hidden;
}
.btn-file input[type='file'] {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
  font-size: 100px;
  text-align: right;
  filter: alpha(opacity=0);
  opacity: 0;
  outline: none;
  background: white;
  cursor: inherit;
  display: block;
}
</style>
